import { FlexBox, Loader } from '@airship-platform/jam-web/components';
import {
  ProposalTemplateOptionsFilterForm,
  ProposalTemplateOptionsFilterFormInputs,
} from '@airship-platform/airship-proposal';
import { Alert } from '@mui/material';
import { useMemo, useState } from 'react';
import { useProposalTemplates } from '../../../data-access/proposalTemplate';
import ProposalTemplateOptionQueryResults from './ProposalTemplateOptionQueryResults';

const ProposalTemplateOptionQuery: React.FC = () => {
  const {
    proposalTemplateOptions,
    isLoadedOptions,
    isLoadingOptions,
    error,
    tags,
    isLoadedTags,
    isLoadingTags,
  } = useProposalTemplates();
  const [filterValues, setFilterValues] =
    useState<ProposalTemplateOptionsFilterFormInputs>({
      searchTerm: '',
      tags: [],
    });

  const filteredTemplateOptions = useMemo(
    () =>
      proposalTemplateOptions.filter(
        (option) =>
          [
            option.name,
            option.products.flatMap((product) => [product.name, product.model]),
          ]
            .flat()
            .join(' ')
            .toLowerCase()
            .includes(filterValues.searchTerm.toLowerCase()) &&
          (!filterValues.tags.length ||
            filterValues.tags.every((tagId) =>
              option.tagIds.some((t) => t === tagId)
            ))
      ),
    [filterValues, proposalTemplateOptions]
  );

  const isLoading = [isLoadingOptions, isLoadingTags].some(Boolean);
  const isLoaded = [isLoadedOptions, isLoadedTags].every(Boolean);

  if (isLoading && !isLoaded) {
    return (
      <Loader
        isLoading={isLoading}
        message="Loading proposal template options..."
      />
    );
  }

  return (
    <FlexBox flexDirection={'column'} gap={3} width={'100%'}>
      {error && (
        <Alert severity="error">
          Oops! There was an unexpected error fetching templates: {error}
        </Alert>
      )}

      <ProposalTemplateOptionsFilterForm
        proposalTemplateTags={tags}
        onChange={setFilterValues}
      />

      <ProposalTemplateOptionQueryResults
        proposalTemplateTags={tags}
        proposalTemplateOptions={filteredTemplateOptions}
      />
    </FlexBox>
  );
};

export default ProposalTemplateOptionQuery;
